module.exports = __webpack_public_path__ + "static/media/complete.a2ccbc38.svg";